import { render, staticRenderFns } from "./OrderSurveyPanel.vue?vue&type=template&id=baafb808&scoped=true"
import script from "./OrderSurveyPanel.vue?vue&type=script&lang=js"
export * from "./OrderSurveyPanel.vue?vue&type=script&lang=js"
import style0 from "./OrderSurveyPanel.vue?vue&type=style&index=0&id=baafb808&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baafb808",
  null
  
)

export default component.exports